import Tabs from "./Tabs";
import TabPane from "./TabPane";

const TabsObj = Object.assign(Tabs, {
  TabPane: TabPane,
});

export default TabsObj;
